<template>
  <div class="lotto-box ru-box">
    <div class="lotto">
      <div class="left">
        <div class="lotto-head">
          <div class="lotto-logo">
            <img src="../../assets/theme/ru-logo.png">
          </div>
          <div class="lotto-date">
            <strong>DATE</strong>
            <div class="date">{{ date }}</div>
          </div>
        </div>
        <div class="lotto-content">
          <div class="number-box">
            <div class="number-l">
              <div class="n-award text-center">
                <img src="../../assets/theme/1.png">
              </div>
              <Show1StSpin lang="ru" :length="5" :results="resultNumbers" result-key="prize_1st" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              <div class="number1st">
                <div class="n-head">1st</div>
                <div class="n-body">
                  <Show1StNumbers length="5" :results="resultNumbers" result-key="prize_1st" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
              <div class="number2nd">
                <div class="n-head">2nd</div>
                <div class="n-body">
                  <Show2NdNumbers length="5" :results="resultNumbers" result-key="prize_2nd" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
            </div>
            <div class="number-r">
              <div class="time">
                <span>{{ time }}</span>
              </div>
              <div class="number3rd">
                <div class="n-head">3rd</div>
                <div class="n-body">
                  <div class="n-list">
                    <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                  </div>
                  <div class="n-list">
                    <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                  </div>
                  <div class="n-list">
                    <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                  </div>
                  <div class="n-list">
                    <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_4" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                  </div>
                  <div class="n-list">
                    <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_5" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                  </div>
                  <div class="n-list">
                    <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_6" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                  </div>
                  <div class="n-list">
                    <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_7" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                  </div>
                  <div class="n-list">
                    <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_8" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <!--
        <div class="banner">
          <img src="../../assets/theme/right-banner.png">
        </div>
        -->
        <HistoryResult lang="ru" :date="resultDate" />
      </div>
    </div>
  </div>
</template>
<script>
import { slotItems } from '@/configs/slot.config.js'

import HistoryResult from './HistoryResult.vue'

import Show1StSpin from './sub/Show1StSpin.vue'
import Show1StNumbers from './sub/Show1StNumbers.vue'
import Show2NdNumbers from './sub/Show2NdNumbers.vue'
import ShowNumbers from './sub/ShowNumbers.vue'

export default {
  name: 'Russia',
  components: {
    HistoryResult,
    Show1StSpin,
    Show1StNumbers,
    Show2NdNumbers,
    ShowNumbers
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    reloadTime: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      updateTime: null,
      updateHistory: null,
      distance: 15, // ระยะห่างของการออกแต่ล่ะเลข (วินาที)
      slotCounting: null,
      CountdownReload: null
    }
  },
  computed: {
    result() {
      if(this.data) {
        return this.data
      }else{
        return null
      }
    },
    prevDraw(){
      if(this.data) {
        return this.data.prev
      }else{
        return null
      }
    },
    nextDraw(){
      if(this.data) {
        return this.data.next
      }else{
        return null
      }
    },
    resultNumbers() {
      if(this.result) {
        return this.result.results
      }else{
        return null
      }
    },
    updateCode() {
      return this.updateTime
    },
    startSpin() {
      if (this.result !== null) {
        return this.result.start_spin
      }else{
        return null
      }
    },
    startShow() {
      if (this.result !== null && this.result.show_2nd) {
        return this.result.show_2nd
      }else{
        return null
      }
    },
    endTime() {
      if (this.result !== null && this.result.show_1st) {
        return this.result.show_1st
      }else{
        return null
      }
    },
    prize1st() {
      if (this.result !== null && this.resultNumbers['prize_1st']) {
        return this.resultNumbers['prize_1st']
      }
      return '-----'
    },
    prize2nd() {
      if (this.result !== null && this.resultNumbers['prize_2nd']) {
        return this.resultNumbers['prize_2nd']
      }else{
        return null
      }
    },
    date() {
      if(this.result) {
        return this.$moment(this.result.lotto_date).format("DD/MM/YY")
      }else{
        return '--/--/--'
      }
    },
    time() {
      if(this.result) {
        return this.$moment(this.result.show_1st).format("HH:mm:ss")
      }else{
        return '--:--:--'
      }
    },
    checkUpdate() {
      return `${this.startSpin}-${this.startShow}-${this.prize1st}-${this.prize2nd}-${this.endTime}-${this.slotCounting}-${this.reloadTime}`
    },
    resultDate() {
      if(this.result) {
        return this.result.lotto_date
      }else{
        return null
      }
    }
  },
  watch: {
    checkUpdate() {
      this.updateTime = new Date().getTime()
      this.calProcess()
    }
  },
  methods: {
    calProcess() {
      console.log('calProcess...')
      // เลยเวลาออกผลมาแล้ว แต่ยังไม่มีผล
      if(this.result && this.prize1st==='-----' && this.$moment().isBetween(this.endTime, this.$moment(this.endTime).add(10, 'm')) ) {
        console.log('ถึงเวลาออกผลแล้ว แต่ไม่มีผล', 'reload after 10 sec')
        clearTimeout(this.CountdownReload)
        this.CountdownReload = setTimeout(()=>{
          this.$emit('reload')
        }, 10000)
      }else
      if(this.result.show_2nd) {
        if(this.endTime!==null && this.$moment().isAfter(this.endTime)) {
          this.slotCounting = slotItems[slotItems.length - 1]
          this.updateTime = new Date().getTime()
        }else
        // ยังไม่ถึงเวลาแสดงค่าแรก
        if(this.$moment().isBefore(this.result.show_2nd)) {
          this.slotCounting = null
          let diff = this.$moment(this.result.show_2nd).diff(this.$moment(), 'milliseconds')
          clearTimeout(this.setTimeoutToshow)
          this.setTimeoutToshow = setTimeout(() => {
            this.calProcess()
          }, diff)
        // ถึงเวลาแสดงค่าแรก
        }else{
          // ระยะเวลาหลังจากแสดงค่าแรก
          let diff = this.$moment().diff(this.$moment(this.result.show_2nd), 'milliseconds')
          let slotIndex = Math.floor(Math.abs(diff) / (this.distance*1000))
          //this.updateTime = new Date().getTime()
          if (slotIndex < slotItems.length) {
            this.slotCounting = slotItems[slotIndex]
          } else {
            this.slotCounting = slotItems[slotItems.length - 1]
          }
        }
      }
    }
  },
  /*created() {
    console.log('this.result', this.result)
  }*/
}
</script>
